import { includes, map, replace, sortBy } from "lodash";
import React from "react";
import { Container } from "react-bootstrap";
import { useGetLocalText } from "../../utils";
import translationText from "../../translation.js";
import useGetResponse from "../../apis/useGetResponse";
import Page from "../../common/component/fragments/Page";

const isTitle = (str) => !includes(str, "•");

const RenderMission = ({ data }) => {
  const { msg1, msg2, msg3 } = useGetLocalText(data, ["msg1", "msg2", "msg3"]);
  const hasTitle = isTitle(msg1);

  return (
    <>
      {hasTitle && (
        <h2
          style={{
            color: "#FAA652",
          }}
        >
          {msg1}
        </h2>
      )}
      <ul>
        {!hasTitle && msg1 && <li>{replace(msg1, "•", "")}</li>}
        {msg2 && <li>{replace(msg2, "•", "")}</li>}
        {msg3 && <li>{replace(msg3, "•", "")}</li>}
      </ul>
    </>
  );
};

const OurMission = () => {
  const { data, isFetching, isError } = useGetResponse("mission");

  return (
    <Page
      isLoading={isFetching || isError}
      pageTitle={translationText.PPDFPA}
    >
      <Container
        id="our-mission"
        style={{ fontSize: "1.5rem", padding: "30px" }}
      >
         <h2 style={{ color: "#FAA652" }}>Privacy Policy</h2>

        <p><strong>App Name:</strong> Drugs Free Pune</p>

        <h3>1. Introduction</h3>
        <p>
          Welcome to Drugs Free Pune. Your privacy is important to us. This
          Privacy Policy explains how we collect, use, and protect your
          information when you use our application.
        </p>

        <h3>2. Information We Collect</h3>
        <p>
          <strong>a) Personal Information:</strong> We may collect basic
          information such as name, email address, or phone number only if
          voluntarily provided by users.
        </p>
        <p>
          <strong>b) Non-Personal Information:</strong> We may collect device
          information, app usage data, and crash reports to improve performance.
        </p>
        <p>
          <strong>c) Permissions:</strong> Our app may request permissions such
          as storage, camera, or location only if required for functionality.
        </p>

        <h3>3. How We Use Information</h3>
        <ul>
          <li>To improve app performance and functionality</li>
          <li>To respond to user queries</li>
          <li>To enhance user experience</li>
          <li>To fix bugs and issues</li>
        </ul>

        <h3>4. Third-Party Services</h3>
        <p>
          We may use third-party services such as Firebase (for analytics and
          crash reporting) and AdMob (for advertisements), which may collect
          information as per their policies.
        </p>

        <h3>5. Data Sharing</h3>
        <p>
          We do not sell, trade, or rent users’ personal information. Data may
          only be shared if required by law.
        </p>

        <h3>6. Data Security</h3>
        <p>
          We take appropriate measures to protect user data, but no method of
          transmission over the internet is 100% secure.
        </p>

        <h3>7. Children's Privacy</h3>
        <p>
          This app is not intended for children under the age of 13. We do not
          knowingly collect personal data from children.
        </p>

        <h3>8. User Rights</h3>
        <p>
          Users may request deletion of their data by contacting us.
        </p>

        <h3>9. Changes to This Policy</h3>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          reflected in this document.
        </p>

        <h3>10. Contact Us</h3>
        <p>For any questions or concerns, contact us at:</p>
        <p><strong>Email:</strong> punepoliceapp@gmail.com</p>
      </Container>
    </Page>
  );
};

export default OurMission;
